import { Plus, ShieldCheck, ShieldAlert } from "lucide-react";
import { C, Panel, Chip, Serif, Label, Avatar } from "./ui";
import { ADMINS, INTEGRATIONS, GATES } from "./adminData";

export default function AdminSettings() {
  return (
    <div>
      <Label>Configuration</Label>
      <Serif size={26} style={{ marginTop: 4, marginBottom: 18 }}>Settings</Serif>

      <div style={{ display: "grid", gridTemplateColumns: "minmax(0,1fr) minmax(0,1fr)", gap: 16 }}>
        <div style={{ display: "grid", gap: 16, alignContent: "start" }}>
          <Panel>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <Label>Admins &amp; roles</Label>
              <button data-testid="settings-add-admin" style={{ display: "flex", alignItems: "center", gap: 5, padding: "6px 11px", background: C.ink, color: "#fff", border: 0, borderRadius: 999, fontSize: 12, fontWeight: 600, cursor: "pointer" }}><Plus size={13} /> Invite</button>
            </div>
            {ADMINS.map((a) => (
              <div key={a.email} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", borderTop: "1px solid rgba(26,30,36,0.06)" }}>
                <Avatar name={a.name} color={C.navy} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 600 }}>{a.name}</div>
                  <div style={{ fontSize: 12, color: C.slate, fontFamily: "'JetBrains Mono', monospace" }}>{a.email}</div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: C.navy }}>{a.role}</div>
                  <Chip color={a.status === "active" ? C.green : C.amber}>{a.status}</Chip>
                </div>
              </div>
            ))}
          </Panel>

          <Panel>
            <Label style={{ marginBottom: 12 }}>Integrations</Label>
            {INTEGRATIONS.map((it) => (
              <div key={it.name} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 0", borderTop: "1px solid rgba(26,30,36,0.06)" }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 600 }}>{it.name}</div>
                  <div style={{ fontSize: 11, color: C.slate, fontFamily: "'JetBrains Mono', monospace" }}>{it.note}</div>
                </div>
                <Chip color={it.ok ? C.green : C.slate}>{it.state}</Chip>
              </div>
            ))}
          </Panel>
        </div>

        <Panel style={{ alignSelf: "start" }}>
          <Label style={{ marginBottom: 6 }}><ShieldCheck size={13} style={{ verticalAlign: "middle" }} /> Safety gates</Label>
          <div style={{ fontSize: 12, color: C.slate, marginBottom: 14 }}>Hard guards that keep dev/demo safe. All off until go-live.</div>
          {GATES.map((g) => (
            <div key={g.key} style={{ padding: "12px 0", borderTop: "1px solid rgba(26,30,36,0.06)" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: 12, fontWeight: 700, fontFamily: "'JetBrains Mono', monospace", color: C.ink }}>{g.key}</span>
                <span style={{ display: "flex", alignItems: "center", gap: 5, fontSize: 12, fontWeight: 700, fontFamily: "'JetBrains Mono', monospace", color: g.value === "false" ? C.red : C.navy }}>
                  {g.value === "false" && <ShieldAlert size={13} />}{g.value}
                </span>
              </div>
              <div style={{ fontSize: 12, color: C.slate, marginTop: 4 }}>{g.desc}</div>
            </div>
          ))}
        </Panel>
      </div>
    </div>
  );
}
